import React from 'react';
import Header from './/header/Header';
import Footer from '../footer/Footer';
import MobileHeroHome from './hero/Hero';
import MobileDemoSection from './demo/Demo';
import MobileFeatureSection from './feature/Feature';
import borderImg from "../../images/mobile/border-line.png";

import borderFlexImg from "../../images/mobile/border-line.png";

import MobileQuestionsSection from './question/Questions';
import MobileRoadMapSection from './roadmap/Roadmap';
import ActionSection from '../action-section/ActionSection';
import MobileTestimonialsSection from './testimonials/Testimonials';

function MobileScreen({ width }) {

  return (
    <div className="flex flex-col min-h-screen overflow-hidden">
      <Header />
      <main className="flex-grow">
        <MobileHeroHome />
        <MobileDemoSection/>
        <MobileFeatureSection />
          <div className="w-full relative flex center">
            <img
              src={borderImg}
              className="w-full"
              alt="border-bg "
            />
          </div>
          <MobileTestimonialsSection />
          <MobileQuestionsSection />
          <div className="w-full relative flex center">
            <img
              src={borderFlexImg}
              className="w-full"
              alt="border-bg "
            />
          </div>
          <MobileRoadMapSection />
          <ActionSection isMobile={width < 768} width={width}/>
      </main>
      <Footer isMobile />

    </div>
  );
}

export default MobileScreen;